/* TealerLab Cart Page — JS controller (réutilise window.tlrCartConfig du drawer) */
(function () {
  const TLR_ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const root = document.querySelector("[data-tlr-cart-page]");
  if (!root) return;

  const CFG = window.tlrCartConfig || {};
  const SAMPLE_THRESHOLD = (CFG.ship?.sample?.cents) || 100;
  const SHIP_THRESHOLD = (CFG.ship?.t1?.cents) || 4900;
  const REWARD_T2 = (CFG.ship?.t2?.cents) || 6900;
  const REWARD_T3 = (CFG.ship?.t3?.cents) || 7900;
  const REWARD_T4 = (CFG.ship?.t4?.cents) || 9900;
  const TS_LABEL = (CFG.ship?.sample?.label) || "Échantillon offert";
  const T1_LABEL = (CFG.ship?.t1?.label) || "Livraison offerte";
  const T2_LABEL = (CFG.ship?.t2?.label) || "Sticker offert";
  const T3_LABEL = (CFG.ship?.t3?.label) || "Grinder offert";
  const T4_LABEL = (CFG.ship?.t4?.label) || "+10g offerts";
  const TS_EMOJI = (CFG.ship?.sample?.emoji) || "🌿";
  const T1_EMOJI = (CFG.ship?.t1?.emoji) || "🚚";
  const T2_EMOJI = (CFG.ship?.t2?.emoji) || "🎁";
  const T3_EMOJI = (CFG.ship?.t3?.emoji) || "🌿";
  const T4_EMOJI = (CFG.ship?.t4?.emoji) || "🔥";
  /**
   * Liste ordonnée des paliers réellement affichés. Un palier décoché dans le customizer
   * (`on: false`) ou sans montant sort de la liste comme s'il n'existait pas ; `on` absent
   * vaut actif (config émise avant l'ajout des cases). `cents` du config prime, y compris
   * 0 — le repli codé ne sert que quand la clé manque.
   */
  function shipTiers(ship, tiers) {
    const out = [];
    for (const t of tiers) {
      const cfg = (ship && ship[t.cfg]) || {};
      const cents = Number.isFinite(cfg.cents) ? cfg.cents : t.cents;
      if (cfg.on === false || !(cents > 0)) continue;
      // `type` et `rewards` viennent du palier lui-même (réglages par palier) : une config
      // émise avant leur ajout n'en a pas, ce qui vaut « Automatique, aucun produit ».
      out.push({ ...t, cents, type: cfg.type || "auto", rewards: Array.isArray(cfg.rewards) ? cfg.rewards : [] });
    }
    return out;
  }

  /**
   * Ce que les paliers débloquent, et à partir de quel montant.
   *
   * Le type est choisi palier par palier dans le customizer. `auto` est le défaut du schéma,
   * donc l'état de toutes les boutiques tant que personne n'y touche : il rejoue le modèle
   * précédent — le palier échantillon ouvre le sélecteur d'échantillons, le palier nommé par
   * « Palier qui débloque le cadeau » ouvre les cadeaux, les autres n'ouvrent rien. Dès qu'UN
   * palier affiché porte un autre type, le modèle par palier prend le relais : seuils lus sur
   * les paliers, un cadeau de plus par palier « cadeau » atteint, et les produits des paliers
   * (les anciens sélecteurs ne servent plus que de repli quand un palier n'en nomme aucun).
   *
   * Montants : un palier à 0 n'existe pas (shipTiers l'a déjà retiré). Dans la branche du
   * modèle précédent, 0 ou absent veut dire « jamais réglé » et garde le montant codé —
   * c'est le comportement actuel des boutiques, le changer déplacerait leurs récompenses.
   *
   * Produits : le catalogue dépend du total. Un palier non atteint n'offre rien, donc les
   * listes se lisent par `sampleRewardsAt(total)` / `giftRewardsAt(total)` à chaque rendu —
   * une liste figée laisserait choisir le cadeau du dernier palier dès le premier.
   */
  function rewardPlan(tiers, legacy) {
    // Another currency without round amounts: no sample, gift or coded fallback threshold.
    if (legacy.off) return { typed: true, blockCents: null, sampleCents: null, giftCents: null, sampleRewardsAt: () => [], giftRewardsAt: () => [], maxGifts: () => 0 };
    const TYPES = ["shipping", "sample", "gift"];
    if (!tiers.some((t) => TYPES.indexOf(t.type) >= 0)) {
      const amount = (v, coded) => (Number.isFinite(v) && v > 0 ? v : coded);
      const sampleCents = amount(legacy.sampleCents, 100);
      const giftCents = amount(legacy.giftCents, 5900);
      const twoGiftsCents = amount(legacy.twoGiftsCents, 9900);
      return {
        typed: false,
        blockCents: sampleCents,
        sampleCents,
        giftCents,
        sampleRewardsAt: () => [],
        giftRewardsAt: () => [],
        maxGifts: (total) => (total >= twoGiftsCents ? 2 : total >= giftCents ? 1 : 0),
      };
    }
    const pick = (type) => tiers.filter((t) => t.type === type);
    // Offert à ce total : un palier non atteint ne donne rien, et deux paliers qui offrent la
    // même variante ne font qu'un bouton (deux jumeaux se désélectionneraient l'un l'autre).
    const rewardsOf = (list, total) => {
      const seen = [];
      return list
        .reduce((all, t) => (total >= t.cents ? all.concat(t.rewards || []) : all), [])
        .filter((r) => {
          if (!r || !r.id || seen.indexOf(String(r.id)) >= 0) return false;
          seen.push(String(r.id));
          return true;
        });
    };
    const sampleTiers = pick("sample");
    const giftTiers = pick("gift");
    const giftSteps = giftTiers.map((t) => t.cents).sort((a, b) => a - b);
    const sampleCents = sampleTiers.length ? Math.min(...sampleTiers.map((t) => t.cents)) : null;
    const giftCents = giftSteps.length ? giftSteps[0] : null;
    const unlocks = [sampleCents, giftCents].filter((c) => c !== null);
    return {
      typed: true,
      blockCents: unlocks.length ? Math.min(...unlocks) : null,
      sampleCents,
      giftCents,
      sampleRewardsAt: (total) => rewardsOf(sampleTiers, total),
      giftRewardsAt: (total) => rewardsOf(giftTiers, total),
      // Un cadeau de plus par palier atteint, jamais plus que de produits distincts à
      // choisir : promettre deux cadeaux devant un seul bouton bloque le client.
      maxGifts: (total) => {
        const reached = giftSteps.filter((c) => total >= c).length;
        const offered = rewardsOf(giftTiers, total).length;
        return offered > 0 ? Math.min(reached, offered) : reached;
      },
    };
  }

  // Paliers dans l'ordre croissant du barème : la barre, ses jalons et les messages ne
  // parlent que de ceux-là — même règle que le drawer et que la section.
  const TIERS = shipTiers(CFG.ship, [
    { key: "ts", cfg: "sample", cents: SAMPLE_THRESHOLD, label: TS_LABEL, emoji: TS_EMOJI },
    { key: "t1", cfg: "t1", cents: SHIP_THRESHOLD, label: T1_LABEL, emoji: T1_EMOJI },
    { key: "t2", cfg: "t2", cents: REWARD_T2, label: T2_LABEL, emoji: T2_EMOJI },
    { key: "t3", cfg: "t3", cents: REWARD_T3, label: T3_LABEL, emoji: T3_EMOJI },
    { key: "t4", cfg: "t4", cents: REWARD_T4, label: T4_LABEL, emoji: T4_EMOJI },
  ]);
  const PLAN = rewardPlan(TIERS, {
    off: CFG.marketOff === true,
    sampleCents: CFG.ship?.sample?.cents,
    giftCents: CFG.gifts?.threshold,
    twoGiftsCents: CFG.ship?.t4?.cents,
  });
  const LOYALTY_POINTS_PER_EURO = CFG.loyalty?.ptsPerEuro ?? 1;
  const LOYALTY_REWARD_PER_POINT = (CFG.loyalty?.rewardPer100Pts ?? 5) / 100;
  // 0 is a legitimate value (no minimum): only a missing one falls back to 10 €.
  const MIN_ORDER = Number.isFinite(CFG.minOrder?.cents) ? CFG.minOrder.cents : 1000;
  const _cleanHandles = (arr) => (arr || []).filter((h) => h && typeof h === "string" && h.trim().length > 0);
  const UPSELL_HANDLES = _cleanHandles(CFG.upsell?.handles);
  const UPSELL_LIMIT = Number.isInteger(CFG.upsell?.limit) && CFG.upsell.limit > 0 ? CFG.upsell.limit : 4;
  const SAMPLE_HANDLES = _cleanHandles(CFG.samples?.handles).length
    ? _cleanHandles(CFG.samples.handles)
    : ["mojo-mango-kush", "green-crack", "gelato-cake", "purple-haze", "hulk-hash"];
  const GIFT_HANDLES = _cleanHandles(CFG.gifts?.handles);
  // Variant titles configurés par l'admin pour chaque slot gift (ex: ["10g","3.5g"])
  const GIFT_VARIANT_TITLES = (CFG.gifts?.variantTitles || []).map(t => (t || "").trim());
  // Codes promo SupaEasy à appliquer auto pour rendre samples/gifts gratuits (100% off tag-based)
  const SAMPLE_CODE = (CFG.gifts?.sampleCode || "").trim();
  const GIFT_CODE = (CFG.gifts?.giftCode || "").trim();
  const GIFT_LOCKED_MSG = CFG.gifts?.lockedMsg || "🔒 Encore {delta} pour débloquer";
  // Translated strings emitted by the drawer section (locales tlr.cart_page.*).
  // Every read keeps the current copy as a fallback so a missing key never blanks the UI.
  const T = CFG.i18n?.page || {};
  // `| t` HTML-escapes every key that does not end in _html, and `| json` keeps the
  // entities: a string that lands in textContent must be decoded first (an innerHTML
  // sink decodes by itself).
  const ENTITIES = { "&amp;": "&", "&lt;": "<", "&gt;": ">", "&quot;": '"', "&#39;": "'" };
  const decodeEntities = (s) => String(s).replace(/&(amp|lt|gt|quot|#39);/g, (m) => ENTITIES[m]);
  const QTY_DECREASE = (T.qtyDecrease || "Diminuer").replace(/"/g, "&quot;");
  const QTY_INCREASE = (T.qtyIncrease || "Augmenter").replace(/"/g, "&quot;");
  const ITEM_REMOVE = (T.itemRemove || "Supprimer").replace(/"/g, "&quot;");

  // Modèle des cadeaux par palier — même fichier que le tiroir, sinon les deux écrans se
  // contredisent (l'un retirerait ce que l'autre vient d'ajouter).
  const GIFTS = window.TlrGiftTiers || null;
  let editingTier = null;
  let giftNotice = "";
  const LEGACY_GIFTS = { cents: PLAN.giftCents, handles: GIFT_HANDLES, variantTitles: GIFT_VARIANT_TITLES };
  const GIFT_CTX = {
    escapeHtml: escapeHTML,
    fmtMoney: (cents) => fmtMoney(cents),
    shortName: (t) => shortRewardName(t),
    i18n: {
      giftsTierPick: CFG.i18n?.giftsTierPick,
      giftsTierLocked: CFG.i18n?.giftsTierLocked,
      giftsClaimedTitle: CFG.i18n?.giftsClaimedTitle,
      giftsChange: CFG.i18n?.giftsChange,
      giftsAllClaimed: CFG.i18n?.giftsAllClaimed,
      giftsPickOne: T.giftsPickOne || CFG.i18n?.giftsPickOne,
    },
  };

  // Même regroupement d'affichage que le tiroir, même module : la page panier et le tiroir
  // ne peuvent pas montrer deux choses différentes du même panier.
  const PACK = window.TlrCartPack || null;
  const PACK_CTX = {
    escapeHtml: escapeHTML,
    fmtMoney: (cents) => fmtMoney(cents),
    editUrl: (CFG.pack && CFG.pack.url) || "",
    i18n: {
      titles: { "pack-builder": CFG.i18n?.packTitle, bundle: CFG.i18n?.bundleTitle },
      packTitle: CFG.i18n?.packTitle,
      packItems: CFG.i18n?.packItems,
      packShow: CFG.i18n?.packShow,
      packHide: CFG.i18n?.packHide,
      packEdit: CFG.i18n?.packEdit,
      remove: T.itemRemove || CFG.i18n?.itemRemove,
    },
  };

  let cartCache = null;
  const compareCache = {};

  const $ = (sel) => root.querySelector(sel);

  // {token} substitution by split/join: every occurrence is replaced and a `$&` inside
  // a customizer label is never re-interpreted, unlike String.replace.
  function fillTokens(tpl, tokens) {
    return Object.keys(tokens).reduce((out, k) => out.split(`{${k}}`).join(tokens[k]), tpl);
  }

  function fmtMoney(cents) {
    try {
      return new Intl.NumberFormat(window.tlr?.locale || "fr-FR", { style: "currency", currency: window.tlr?.currency || "EUR" }).format((cents || 0) / 100);
    } catch (_) {
      return ((cents || 0) / 100).toFixed(2) + " " + (window.tlr?.currency || "EUR");
    }
  }

  /** Round amounts without decimals ("69 €", "£69"), the way the tier scale reads. */
  function fmtMoneyWhole(cents) {
    try {
      return new Intl.NumberFormat(window.tlr?.locale || "fr-FR", { style: "currency", currency: window.tlr?.currency || "EUR", minimumFractionDigits: cents % 100 ? 2 : 0 }).format((cents || 0) / 100);
    } catch (_) {
      return fmtMoney(cents);
    }
  }

  /** Échappe le HTML d'une valeur injectée dans un gabarit (titres, handles, URL d'image). */
  function escapeHTML(str) {
    if (str == null) return "";
    return String(str)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#39;");
  }

  /** Nom court affiché sur un bouton récompense (le préfixe interne « TLR Cart » ne sort pas). */
  function shortRewardName(title) {
    return String(title || "").replace(/^TLR Cart\s*/i, "").trim().split(" ").slice(0, 3).join(" ");
  }

  /**
   * Boutons d'une colonne récompense à partir des produits déjà résolus par la section
   * (id de variante, titre, grammage, image) : aucun aller-retour /products/<handle>.js.
   */
  function rewardButtonsHtml(rewards, type) {
    const idAttr = type === "gift" ? "data-gift-variant" : "data-sample-variant";
    const handleAttr = type === "gift" ? "data-gift-handle" : "data-sample-handle";
    return (rewards || []).map((r) => {
      const variantTitle = String(r.variantTitle || "");
      return `
        <button type="button" class="tlr-cart__sample-btn${variantTitle ? " tlr-cart__sample-btn--variant" : ""}" ${idAttr}="${escapeHTML(String(r.id))}" ${handleAttr}="${escapeHTML(r.handle || "")}">
          ${r.image ? `<img src="${escapeHTML(r.image)}" alt="${escapeHTML(r.title || "")}" loading="lazy">` : ""}
          <span class="tlr-cart__sample-name">${escapeHTML(shortRewardName(r.title))}</span>
          ${variantTitle ? `<span class="tlr-cart__sample-variant">${escapeHTML(variantTitle)}</span>` : ""}
        </button>`;
    }).join("");
  }

  /**
   * Marque une grille récompense à reconstruire quand le catalogue offert change : le
   * contenu dépend du total (un palier franchi ajoute des produits), le drapeau « déjà
   * chargé » figerait sinon la grille sur le premier rendu du panier.
   */
  function rearmRewardGrid(grid, rewards) {
    const key = rewards.map((r) => r.id).join(",");
    if (grid.dataset.rewardKey === key) return;
    grid.dataset.rewardKey = key;
    grid.dataset.loaded = "";
  }

  async function loadComparePrices(items) {
    const handles = [...new Set((items || []).map((i) => i.handle).filter((h) => h && !(h in compareCache)))];
    if (!handles.length) return;
    await Promise.all(
      handles.map(async (handle) => {
        try {
          const r = await fetch(`${TLR_ROOT}products/${handle}.js`, { cache: "force-cache" });
          const p = await r.json();
          compareCache[handle] = {};
          (p.variants || []).forEach((v) => {
            compareCache[handle][v.id] = v.compare_at_price || 0;
          });
        } catch (_) {
          compareCache[handle] = {};
        }
      })
    );
  }

  // Total RÉEL des items payants (exclut samples/gifts/EasyGift _Gifted)
  // Utilisé pour évaluer les paliers (ship bar, max gifts, samples block)
  // — pas affecté par cart-level discounts (codes promo) pour éviter le cercle vicieux
  function computeRealPaidTotal() {
    if (!cartCache) return 0;
    return (cartCache.items || []).reduce((acc, it) => {
      const p = it.properties || {};
      const isOurFreebie = p._is_gift === "true" || p._is_gift === true || p._is_sample === "true" || p._is_sample === true;
      const isEgGift = !!p._Gifted;
      if (isOurFreebie || isEgGift) return acc;
      return acc + (it.final_line_price || 0) + giftAllocationOn(it);
    }, 0);
  }

  /** Voir le tiroir : la remise « offert » peut tomber sur une unité payante du même variant. */
  function giftAllocationOn(item) {
    const label = String(CFG.i18n?.giftFree || "").trim().toLowerCase();
    if (!label) return 0;
    return (item.line_level_discount_allocations || []).reduce((sum, a) => {
      const title = String(a?.discount_application?.title || "").trim().toLowerCase();
      return sum + (title === label ? (a.amount || 0) : 0);
    }, 0);
  }

  async function refresh() {
    try {
      const r = await fetch(TLR_ROOT + "cart.js", { cache: "no-store" });
      cartCache = await r.json();
      // Même logique que le drawer : si l'user vide ses payants, on retire
      // sample + gift TLR. Les gifts EasyGift (_Gifted) sont gérés par EG.
      // Une seule règle de total payant, celle de computeRealPaidTotal().
      const realPaidTotal = computeRealPaidTotal();
      // L'échantillon ne survit pas sous le palier qui l'a débloqué — la colonne est
      // masquée en dessous, le client ne pourrait plus le retirer lui-même.
      const sampleLine = (cartCache.items || []).find((it) => {
        const p = it.properties || {};
        return p._is_sample === "true" || p._is_sample === true;
      });
      if (sampleLine && (PLAN.sampleCents === null || realPaidTotal < PLAN.sampleCents)) {
        try { await cartRemoveByKey(sampleLine.key); } catch (_) {}
        // Re-fetch après remove
        const r2 = await fetch(TLR_ROOT + "cart.js", { cache: "no-store" });
        cartCache = await r2.json();
      }
      // Cadeaux : un par palier, identifié par `_tlr_tier`. On retire exactement le cadeau
      // du palier repassé sous son seuil, jamais « le plus ancien ».
      if (GIFTS) {
        giftNotice = "";
        const tiers = await GIFTS.ensureTiers(TIERS, LEGACY_GIFTS);
        const giftState = GIFTS.computeState(tiers, cartCache.items || [], realPaidTotal);
        if (giftState.stale.length) {
          for (const stale of giftState.stale) {
            try { await cartRemoveByKey(stale.line.key); } catch (_) {}
            if (stale.tier) {
              giftNotice = GIFTS.fill(CFG.i18n?.giftRemoved || "", "amount", fmtMoney(stale.tier.cents));
            }
          }
          const r3 = await fetch(TLR_ROOT + "cart.js", { cache: "no-store" });
          cartCache = await r3.json();
        }
      }
      await loadComparePrices(cartCache.items || []);
      render();
    } catch (_) {}
  }

  function render() {
    if (!cartCache) return;
    window.tlr?.events?.syncCart?.(cartCache);
    renderShipping();
    renderItems();
    bindItemsDelegation();
    renderTotal();
    renderLoyalty();
    renderSamples();
    renderUpsell();
    const countEl = $("[data-tlr-cart-count]");
    if (countEl) countEl.textContent = cartCache.item_count || 0;
  }

  function findGiftLine(type) {
    return (cartCache?.items || []).find((it) => {
      const p = it.properties || {};
      if (type === "gift") return p._is_gift === "true" || p._is_gift === true;
      if (type === "sample") return p._is_sample === "true" || p._is_sample === true;
      return false;
    }) || null;
  }
  function findAllGiftLines() {
    return (cartCache?.items || []).filter((it) => {
      const p = it.properties || {};
      return p._is_gift === "true" || p._is_gift === true;
    });
  }
  function syncGiftButtons(grid, type) {
    if (!grid) return;
    const dataAttr = type === "gift" ? "data-gift-variant" : "data-sample-variant";
    const dataKey = type === "gift" ? "giftVariant" : "sampleVariant";
    if (type === "gift") {
      const activeIds = new Set(findAllGiftLines().map(l => l.variant_id));
      grid.querySelectorAll(`[${dataAttr}]`).forEach((btn) => {
        const id = parseInt(btn.dataset[dataKey], 10);
        btn.classList.toggle("is-selected", activeIds.has(id));
      });
    } else {
      const line = findGiftLine(type);
      const activeVId = line?.variant_id ?? null;
      grid.querySelectorAll(`[${dataAttr}]`).forEach((btn) => {
        const id = parseInt(btn.dataset[dataKey], 10);
        btn.classList.toggle("is-selected", !!activeVId && id === activeVId);
      });
    }
  }
  async function cartRemoveByKey(key) {
    const r = await fetch(TLR_ROOT + "cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ id: key, quantity: 0 }),
    });
    if (r.ok) cartCache = await r.json();
  }
  async function handleGiftClick(variantId, type, grid, btn) {
    btn.disabled = true;
    const vId = parseInt(variantId, 10);

    // Helper local pour appliquer un code promo silencieusement
    const applyCode = async (code) => {
      if (!code) return;
      try {
        await fetch(`/discount/${encodeURIComponent(code)}`, { redirect: "follow", credentials: "same-origin" });
      } catch (_) {}
    };

    if (type === "sample") {
      // Sample = toggle simple (max 1)
      const currentLine = findGiftLine("sample");
      if (currentLine && currentLine.variant_id === vId) {
        try { await cartRemoveByKey(currentLine.key); } catch (_) {}
      } else {
        if (currentLine) { try { await cartRemoveByKey(currentLine.key); } catch (_) {} }
        try {
          await fetch(TLR_ROOT + "cart/add.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ items: [{ id: vId, quantity: 1, properties: { _tlr: "v2", _is_sample: "true" } }] }),
          });
          await applyCode(SAMPLE_CODE);
        } catch (_) {}
      }
      await refresh();
      document.dispatchEvent(new CustomEvent("cart:updated"));
      btn.disabled = false;
      return;
    }

    // Les cadeaux passent par handleGiftPick : un choix par palier.
    btn.disabled = false;
  }

  /** Clic sur un cadeau — même règle que le tiroir, même module. */
  async function handleGiftPick(btn) {
    if (!GIFTS || !btn || btn.disabled) return;
    const variantId = parseInt(btn.dataset.giftVariant, 10);
    const tierKey = String(btn.dataset.giftTier || "");
    if (!variantId || !tierKey) return;
    const state = GIFTS.computeState(GIFTS.tiersOf(TIERS), cartCache?.items || [], computeRealPaidTotal());
    const row = state.rows.find((r) => r.tier.key === tierKey);
    if (!row || !row.reached) return;

    const wasSelected = btn.classList.contains("is-selected");
    const choices = btn.closest(".tlr-cart__gift-choices");
    if (choices) choices.querySelectorAll(".is-selected").forEach((b) => b.classList.remove("is-selected"));
    if (!wasSelected) btn.classList.add("is-selected");
    btn.disabled = true;

    await GIFTS.run(async () => {
      try {
        if (row.line && row.line.variant_id === variantId) {
          await GIFTS.removeKey(row.line.key);
        } else if (row.line) {
          await GIFTS.swap(row.line.key, variantId, tierKey);
        } else {
          await GIFTS.add(variantId, tierKey);
        }
        giftNotice = "";
        editingTier = null;
      } catch (err) {
        btn.classList.toggle("is-selected", wasSelected);
        if (err && err.status === 422) {
          GIFTS.markUnavailable(variantId);
          btn.classList.add("is-unavailable");
        }
        giftNotice = CFG.i18n?.giftUnavailable || "";
      }
      await refresh();
      document.dispatchEvent(new CustomEvent("cart:updated"));
    });
  }

  async function renderSamples() {
    const block = $("[data-tlr-cart-samples]");
    if (!block) return;
    const total = computeRealPaidTotal();
    // Le bloc s'ouvre au premier palier qui donne quelque chose : l'échantillon (modèle
    // précédent), ou le premier palier récompense quand les paliers portent un type.
    if (PLAN.blockCents === null || total < PLAN.blockCents) { block.hidden = true; return; }
    block.hidden = false;

    // ── Col gauche : échantillons (lazy load 1×)
    const sampleCol = $("[data-tlr-sample-section]");
    const sampleGrid = $("[data-tlr-samples-grid]");
    const sampleUnlocked = PLAN.sampleCents !== null && total >= PLAN.sampleCents;
    const sampleRewards = PLAN.sampleRewardsAt(total);
    // Aucun palier ne donne d'échantillon : la colonne n'a rien à proposer.
    if (sampleCol) sampleCol.hidden = !sampleUnlocked;
    if (sampleGrid) rearmRewardGrid(sampleGrid, sampleRewards);
    if (sampleUnlocked && sampleGrid && sampleGrid.dataset.loaded !== "true") {
      sampleGrid.dataset.loaded = "true";
      if (sampleRewards.length) {
        sampleGrid.innerHTML = rewardButtonsHtml(sampleRewards, "sample");
      } else {
        const pending = sampleGrid.dataset.rewardKey;
        const samples = await Promise.all(
          SAMPLE_HANDLES.slice(0, 2).map((h) =>
            fetch(`${TLR_ROOT}products/${h}.js`).then((r) => (r.ok ? r.json() : null)).catch(() => null)
          )
        );
        // Catalogue changé pendant l'appel : un rendu plus récent a déjà repris la main.
        if (sampleGrid.dataset.rewardKey !== pending) return;
        sampleGrid.innerHTML = samples.filter(Boolean).map((s) => `
          <button type="button" class="tlr-cart__sample-btn" data-sample-variant="${escapeHTML(String(s.variants[0].id))}" data-sample-handle="${escapeHTML(s.handle)}">
            ${s.featured_image ? `<img src="${escapeHTML(s.featured_image)}" alt="${escapeHTML(s.title || "")}" loading="lazy">` : ""}
            <span>${escapeHTML(shortRewardName(s.title))}</span>
          </button>`).join("");
      }
      sampleGrid.querySelectorAll("[data-sample-variant]").forEach((btn) => {
        btn.addEventListener("click", () => handleGiftClick(btn.dataset.sampleVariant, "sample", sampleGrid, btn));
      });
    }
    if (sampleGrid) syncGiftButtons(sampleGrid, "sample");

    // ── Col droite : cadeaux, un palier à la fois (même modèle que le tiroir)
    renderGiftColumn(total);
  }

  /**
   * Colonne cadeau de la page panier : récap des paliers pris, puis le palier ouvert ou
   * l'aperçu du suivant. Tout vient du panier, donc un cadeau retiré dans la liste des
   * articles rouvre son palier au rendu suivant.
   */
  async function renderGiftColumn(total) {
    const section = $("[data-tlr-gift-section]");
    const grid = $("[data-tlr-gift-grid]");
    if (!section || !grid || !GIFTS) return;

    const tiers = await GIFTS.ensureTiers(TIERS, LEGACY_GIFTS);
    const state = GIFTS.computeState(tiers, cartCache?.items || [], total);
    section.hidden = !state.any;
    if (!state.any) return;
    bindGiftDelegation(section);

    if (editingTier && !state.claimed.some((r) => r.tier.key === editingTier)) editingTier = null;
    const editingRow = editingTier ? state.rows.find((r) => r.tier.key === editingTier) : null;
    const openRow = editingRow || state.active;
    section.dataset.state = openRow || state.claimed.length ? "unlocked" : "locked";

    const label = section.querySelector(".tlr-cartpage__samples-col-eye");
    if (label) {
      const text = openRow
        ? GIFTS.fill(CFG.i18n?.giftsTierPick || "", "amount", fmtMoney(openRow.tier.cents))
        : GIFTS.headline(state, GIFT_CTX);
      label.textContent = decodeEntities(text || T.giftsPickOne || CFG.i18n?.giftsPickOne || "");
    }

    const parts = [];
    if (giftNotice) parts.push(`<p class="tlr-cart__gift-note" role="status">${escapeHTML(giftNotice)}</p>`);
    parts.push(GIFTS.claimedHtml(state, GIFT_CTX));
    if (openRow) {
      const selected = editingRow && editingRow.line ? editingRow.line.variant_id : null;
      parts.push(
        `<div class="tlr-cartpage__samples-grid tlr-cart__gift-choices" data-tlr-entry="gift">${GIFTS.gridHtml(openRow, GIFT_CTX, selected)}</div>`
      );
    } else if (state.next) {
      parts.push(GIFTS.lockedHtml(state.next, total, GIFT_CTX));
    }
    grid.className = "tlr-cart__gift-body";
    grid.innerHTML = parts.filter(Boolean).join("");
    grid.dataset.loaded = "true";
  }

  /** Un seul écouteur pour la colonne : son contenu est reconstruit à chaque rendu. */
  function bindGiftDelegation(section) {
    if (section.dataset.tlrGiftBound === "1") return;
    section.dataset.tlrGiftBound = "1";
    section.addEventListener("click", (e) => {
      const edit = e.target.closest("[data-gift-edit]");
      if (edit) {
        editingTier = String(edit.dataset.giftEdit || "");
        giftNotice = "";
        renderGiftColumn(computeRealPaidTotal());
        return;
      }
      const pick = e.target.closest("[data-gift-variant]");
      if (pick) handleGiftPick(pick);
    });
  }

  function shipMessage(total, nextIdx) {
    if (nextIdx < 0) {
      return fillTokens(T.shipAllHtml || "🎉 <strong>Tout est débloqué</strong> — {rewards} !",
        { rewards: TIERS.map((t) => t.label).join(" + ") });
    }
    if (total <= 0) {
      const scaleItem = T.shipScaleItemHtml || "{label} dès <strong>{amount}</strong>";
      return TIERS.map((t) => fillTokens(scaleItem, { label: t.label, amount: fmtMoneyWhole(t.cents) })).join(" · ");
    }
    const next = TIERS[nextIdx];
    const delta = fmtMoney(next.cents - total);
    if (nextIdx === 0) {
      return fillTokens(T.shipNextHtml || "Plus que <strong>{delta}</strong> pour <strong>{reward}</strong> {emoji}",
        { delta, reward: next.label, emoji: next.emoji });
    }
    return fillTokens(T.shipReachedNextHtml || "{reached} 🎉 + plus que <strong>{delta}</strong> pour <strong>{reward}</strong>",
      { reached: TIERS[nextIdx - 1].label, delta, reward: next.label });
  }

  function renderShipping() {
    const ship = $("[data-tlr-cart-ship]");
    if (!ship || !TIERS.length) return;
    const total = computeRealPaidTotal();
    // L'échelle de la barre est portée par le dernier palier actif, pas par le palier 4.
    const scale = TIERS[TIERS.length - 1].cents;
    const fill = $("[data-tlr-ship-fill]");
    if (fill) fill.style.width = Math.min(100, (total / scale) * 100) + "%";
    const nextIdx = TIERS.findIndex((t) => total < t.cents);
    const msg = $("[data-tlr-ship-msg]");
    if (msg) msg.innerHTML = shipMessage(total, nextIdx);
    // Jalon et libellé retrouvés par la CLÉ du palier : deux paliers au même montant, ou un
    // montant décimal, s'allumaient au hasard avec une recherche par valeur en euros.
    TIERS.forEach((t) => {
      const ms = $(`[data-tlr-milestone="${t.key}"]`);
      const reward = $(`[data-tlr-reward="${t.key}"]`);
      ms?.classList.toggle("is-reached", total >= t.cents);
      reward?.classList.toggle("is-active", total >= t.cents);
    });
  }

  function renderItems() {
    const wrap = $("[data-tlr-cart-items]");
    const empty = $("[data-tlr-cart-empty]");
    const checkoutBtn = $("[data-tlr-cart-checkout]");
    const minEl = $("[data-tlr-cart-min-order]");
    if (!wrap) return;

    if (!cartCache.items || cartCache.items.length === 0) {
      // Garde l'empty state visible (déjà rendu côté Liquid)
      if (empty) empty.hidden = false;
      // Supprime les articles s'il y en avait (re-render)
      [...wrap.querySelectorAll(".tlr-cart__item")].forEach((n) => n.remove());
      if (checkoutBtn) checkoutBtn.setAttribute("disabled", "");
      if (minEl) minEl.hidden = true;
      return;
    }
    if (empty) empty.hidden = true;

    const _realTotal = (cartCache.items || []).reduce((acc, it) => {
      const p = it.properties || {};
      const isFreebie = p._is_gift === "true" || p._is_gift === true || p._is_sample === "true" || p._is_sample === true;
      return acc + (isFreebie ? 0 : (it.final_line_price || 0));
    }, 0);

    if (_realTotal < MIN_ORDER) {
      if (checkoutBtn) checkoutBtn.setAttribute("disabled", "");
      if (minEl) {
        const delta = fmtMoney(MIN_ORDER - _realTotal);
        minEl.textContent = decodeEntities(fillTokens(T.minOrderMsg || "Plus que {delta} pour pouvoir commander", { delta }));
        minEl.hidden = false;
      }
    } else {
      if (checkoutBtn) checkoutBtn.removeAttribute("disabled");
      if (minEl) minEl.hidden = true;
    }

    const shopifyDiscountActive = (cartCache.total_discount || 0) > 0;
    const subDiscountPctItems = parseInt(window.tlr?.ovri?.discount_pct, 10) || 15;

    // Construit le markup des items et l'insère APRES le node empty (qu'on garde caché)
    // Les lignes du pack laissent place à une ligne unique, posée à l'emplacement de la
    // première ; les autres articles gardent leur index pour /cart/change.js.
    const packs = PACK ? PACK.groups(cartCache.items) : [];
    const groupByKey = new Map();
    packs.forEach((g) => g.keys.forEach((k) => groupByKey.set(k, g)));
    const itemsHtml = cartCache.items.map((item, idx) => {
      const group = groupByKey.get(item.key);
      if (group) {
        return item.key === group.firstKey ? PACK.rowHtml(group, PACK_CTX) : "";
      }
      const titleEsc = escapeHTML(item.product_title || "");
      const props = item.properties || {};
      const isGift = props._is_gift === "true" || props._is_gift === true;
      const isSample = props._is_sample === "true" || props._is_sample === true;
      const isFreebie = isGift || isSample;
      const isSub = props._subscription === "1" || props._subscription === 1;
      const subLabel = isSub ? (props["📦 Abonnement"] || props._subscription_frequency || "Abonnement") : "";
      const subBadge = isSub
        ? `<span class="tlr-cart__item-sub" title="Abonnement OVRI"><span aria-hidden="true">🔁</span>${escapeHTML(subLabel)}</span>`
        : "";
      // Ligne offerte : pastille « offert » + valeur barrée de l'article. Le type (cadeau ou
      // échantillon) n'est pas écrit dans la pastille, il est porté par son libellé accessible.
      const freeType = ((isGift ? CFG.i18n?.giftTypeGift : CFG.i18n?.giftTypeSample) || "").replace(/"/g, "&quot;");
      const freeValue = item.original_line_price || item.line_price || 0;
      const freeBadge = isFreebie
        ? `<span class="tlr-cart__item-gift">
             <span class="tlr-cart__item-badge is-gift" title="${freeType}" aria-label="${freeType}">${CFG.i18n?.giftFree || ""}</span>
             ${freeValue > 0 ? `<s class="tlr-cart__item-gift-was">${fmtMoney(freeValue)}</s>` : ""}
           </span>`
        : "";
      let priceBlock;
      if (isSub) {
        let origPrice, finalPrice;
        if (shopifyDiscountActive) {
          origPrice = item.original_line_price || item.line_price || 0;
          finalPrice = item.final_line_price || item.line_price || origPrice;
          if (finalPrice >= origPrice) {
            finalPrice = Math.round((origPrice * (100 - subDiscountPctItems)) / 100);
          }
        } else {
          origPrice = item.line_price || item.final_line_price || 0;
          finalPrice = Math.round((origPrice * (100 - subDiscountPctItems)) / 100);
        }
        priceBlock = `
          <div class="tlr-cart__item-price-stack">
            <s class="tlr-cart__item-price-orig">${fmtMoney(origPrice)}</s>
            <strong class="tlr-cart__item-price tlr-cart__item-price--sub">${fmtMoney(finalPrice)}</strong>
          </div>`;
      } else {
        const linePrice = item.final_line_price || item.line_price || 0;
        const compareUnit = item.compare_at_price || compareCache[item.handle]?.[item.variant_id] || 0;
        const compareTotal = compareUnit * (item.quantity || 1);
        const hasCompare = compareTotal > linePrice;
        priceBlock = hasCompare
          ? `<div class="tlr-cart__item-price-stack">
               <s class="tlr-cart__item-price-orig">${fmtMoney(compareTotal)}</s>
               <strong class="tlr-cart__item-price tlr-cart__item-price--sale">${fmtMoney(linePrice)}</strong>
             </div>`
          : `<strong class="tlr-cart__item-price">${fmtMoney(linePrice)}</strong>`;
      }
      // Cadeaux/échantillons : ni prix ni quantité, la pastille et la valeur barrée portent
      // toute l'information — la rangée du bas n'est donc pas émise pour eux.
      if (isFreebie) priceBlock = "";
      const qtyBlock = isFreebie
        ? ""
        : `<div class="tlr-cart__item-qty">
              <button type="button" data-qty-action="decrease" aria-label="${QTY_DECREASE}">−</button>
              <span>${item.quantity}</span>
              <button type="button" data-qty-action="increase" aria-label="${QTY_INCREASE}">+</button>
            </div>`;
      const bottomBlock = (qtyBlock || priceBlock)
        ? `<div class="tlr-cart__item-bottom">${qtyBlock}${priceBlock}</div>`
        : "";
      const closeSvg = `<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>`;
      return `
      <article class="tlr-cart__item${isSub ? " is-sub" : ""}${isFreebie ? " is-freebie" : ""}" data-line="${idx + 1}" data-key="${escapeHTML(item.key || "")}">
        <img class="tlr-cart__item-img" src="${escapeHTML(item.image || "")}" alt="${titleEsc}" loading="lazy">
        <div class="tlr-cart__item-info">
          <div class="tlr-cart__item-top">
            <h4 class="tlr-cart__item-name">${escapeHTML(item.product_title || "")}</h4>
            <button type="button" class="tlr-cart__item-remove" data-qty-action="remove" aria-label="${ITEM_REMOVE}">${closeSvg}</button>
          </div>
          ${item.variant_title && item.variant_title !== "Default Title" ? `<span class="tlr-cart__item-variant">${escapeHTML(item.variant_title)}</span>` : ""}
          ${subBadge}${freeBadge}
          ${bottomBlock}
        </div>
      </article>`;
    }).join("");

    // Remove existing items but keep the empty placeholder
    [...wrap.querySelectorAll(".tlr-cart__item")].forEach((n) => n.remove());
    wrap.insertAdjacentHTML("beforeend", itemsHtml);
  }

  let _itemsBound = false;
  function bindItemsDelegation() {
    if (_itemsBound) return;
    const wrap = $("[data-tlr-cart-items]");
    if (!wrap) return;
    wrap.addEventListener("click", async (e) => {
      const packToggle = e.target.closest("[data-pack-toggle]");
      if (packToggle && PACK) { PACK.toggle(packToggle); return; }
      const packRemove = e.target.closest("[data-pack-remove]");
      if (packRemove) {
        const row = packRemove.closest("[data-pack-group]");
        const keys = String(row?.dataset.keys || "").split(",").filter(Boolean);
        if (!keys.length) return;
        packRemove.disabled = true;
        (async () => {
          for (const key of keys) {
            try { await cartRemoveByKey(key); } catch (_) {}
          }
          await refresh();
          document.dispatchEvent(new CustomEvent("cart:updated"));
        })();
        return;
      }
      const btn = e.target.closest("[data-qty-action]");
      if (!btn) return;
      e.preventDefault();
      const item = btn.closest("[data-line]");
      if (!item) return;
      const line = parseInt(item.dataset.line, 10);
      const action = btn.dataset.qtyAction;
      const cartItem = cartCache?.items?.[line - 1];
      if (!cartItem) return;
      let newQty = cartItem.quantity;
      if (action === "increase") newQty++;
      else if (action === "decrease") newQty = Math.max(0, newQty - 1);
      else if (action === "remove") newQty = 0;
      btn.disabled = true;
      try {
        const res = await fetch(TLR_ROOT + "cart/change.js", {
          method: "POST",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify({ line, quantity: newQty }),
        });
        // 0 is a removal, not a quantity.
        if (res.ok && newQty >= 1 && newQty <= 999) {
          window.tlr?.events?.publish?.("tlr_quantity", { product: String(cartItem.product_id), variant: String(cartItem.variant_id), qty: newQty });
        }
        await refresh();
        // Notifie les autres modules cart (drawer, header bubble, etc.)
        document.dispatchEvent(new CustomEvent("cart:updated", { detail: { silent: true, source: "cart-page" } }));
      } catch (err) {
        console.warn("[cart-page] change failed", err);
      } finally {
        btn.disabled = false;
      }
    });
    _itemsBound = true;
  }

  function renderTotal() {
    const totalEl = $("[data-tlr-cart-total]");
    const origEl = $("[data-tlr-cart-total-original]");
    const savingsEl = $("[data-tlr-cart-savings]");
    const total = cartCache.total_price || 0;
    const totalDiscount = cartCache.total_discount || 0;
    const originalTotal = total + totalDiscount;

    if (totalEl) totalEl.textContent = fmtMoney(total);
    if (origEl) {
      if (totalDiscount > 0 && originalTotal > total) {
        origEl.textContent = fmtMoney(originalTotal);
        origEl.hidden = false;
      } else {
        origEl.hidden = true;
      }
    }
    if (savingsEl) {
      if (totalDiscount > 0) {
        savingsEl.innerHTML = `<span>${T.savings || "🎉 Économies"}</span><strong>−${fmtMoney(totalDiscount)}</strong>`;
        savingsEl.hidden = false;
      } else {
        savingsEl.hidden = true;
      }
    }
  }

  function renderLoyalty() {
    const block = $("[data-tlr-cart-loyalty]");
    if (!block) return;
    if (!cartCache.items || cartCache.items.length === 0) {
      block.hidden = true;
      return;
    }
    const total = cartCache.total_price || 0;
    const pts = Math.floor((total / 100) * LOYALTY_POINTS_PER_EURO);
    const ptsEl = block.querySelector("[data-tlr-loyalty-pts]");
    if (ptsEl) ptsEl.textContent = pts;
    if (CFG.loyalty?.loggedIn) {
      const balEl = block.querySelector("[data-tlr-loyalty-balance]");
      if (balEl) {
        const current = parseInt(CFG.loyalty?.balance || 0, 10);
        balEl.textContent = current + pts;
      }
    }
    block.hidden = false;
  }

  let _upsellRendered = false;
  async function renderUpsell() {
    const block = $("[data-tlr-cart-upsell]");
    if (!block) return;
    if (!UPSELL_HANDLES.length) {
      block.hidden = true;
      return;
    }
    // Ne render qu'une fois (le contenu est statique côté config)
    if (_upsellRendered) {
      block.hidden = false;
      return;
    }
    const list = $("[data-tlr-upsell-list]");
    if (!list) return;
    try {
      const products = await Promise.all(
        UPSELL_HANDLES.slice(0, UPSELL_LIMIT).map((h) =>
          fetch(`${TLR_ROOT}products/${h}.js`, { cache: "force-cache" })
            .then((r) => (r.ok ? r.json() : null))
            .catch(() => null)
        )
      );
      const html = products
        .filter(Boolean)
        .map((p) => {
          const v = p.variants?.[0];
          if (!v) return "";
          const price = v.price || p.price || 0;
          // The price shown is this variant's: its format (5g) belongs in the title.
          const title = v.title && v.title !== "Default Title" ? `${p.title || ""} · ${v.title}` : (p.title || "");
          return `
        <a href="${TLR_ROOT}products/${escapeHTML(p.handle || "")}" class="tlr-cartpage__upsell-card">
          <img src="${escapeHTML(p.featured_image || "")}" alt="${escapeHTML(title)}" loading="lazy" width="120" height="120">
          <div class="tlr-cartpage__upsell-card-info">
            <span class="tlr-cartpage__upsell-card-title">${escapeHTML(title)}</span>
            <strong class="tlr-cartpage__upsell-card-price">${fmtMoney(price)}</strong>
          </div>
        </a>`;
        })
        .join("");
      if (html) {
        list.innerHTML = html;
        block.hidden = false;
        _upsellRendered = true;
      }
    } catch (_) {}
  }

  const checkoutBtn = $("[data-tlr-cart-checkout]");
  if (checkoutBtn) {
    checkoutBtn.addEventListener("click", () => {
      if (checkoutBtn.hasAttribute("disabled")) return;
      window.location.href = TLR_ROOT + "checkout";
    });
  }

  document.addEventListener("cart:updated", () => refresh());

  refresh();
})();

/* Style additionnel pour les cards upsell — appended at end so CSS-in-JS not needed in section */
(function injectUpsellStyles() {
  if (document.getElementById("tlr-cartpage-upsell-css")) return;
  const css = `
.tlr-cartpage__upsell-card {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 12px;
  background: #fff;
  border: 1.5px solid rgba(11,11,11,.08);
  border-radius: 14px;
  text-decoration: none;
  color: inherit;
  transition: transform 0.2s ease, border-color 0.2s ease;
}
.tlr-cartpage__upsell-card:hover {
  transform: translateY(-2px);
  border-color: var(--tlr-ink, #0b0b0b);
}
.tlr-cartpage__upsell-card img {
  width: 100%;
  aspect-ratio: 1;
  object-fit: cover;
  border-radius: 10px;
  background: var(--tlr-paper, #fafaf7);
}
.tlr-cartpage__upsell-card-info {
  display: flex;
  flex-direction: column;
  gap: 2px;
}
.tlr-cartpage__upsell-card-title {
  font-size: 0.8125rem;
  line-height: 1.3;
  font-weight: 600;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.tlr-cartpage__upsell-card-price {
  font-family: "Bebas Neue", Inter, system-ui, sans-serif;
  font-size: 1.125rem;
}
`;
  const style = document.createElement("style");
  style.id = "tlr-cartpage-upsell-css";
  style.textContent = css;
  document.head.appendChild(style);
})();
